import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var minimalSeamsIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.9 19.034 3.077 1.671a1 1 0 0 1 .402 1.356l-.24.439-3.074-1.67a1 1 0 0 1-.402-1.356l.238-.44Zm7.738-15.69.24.437a.998.998 0 0 1-.391 1.358L8.053 12l12.434 6.86a1 1 0 0 1 .392 1.36l-.241.436-14.104-7.78a1 1 0 0 1 0-1.752l14.104-7.78ZM7.628 16.171l3.076 1.67a1 1 0 0 1 .402 1.356l-.239.439-3.076-1.67a1 1 0 0 1-.402-1.355l.24-.44Zm-5.273-2.864 3.076 1.67c.485.264.665.871.402 1.357l-.239.44-3.076-1.67a1.001 1.001 0 0 1-.402-1.357l.24-.44Zm3.24-6.082.238.44a1 1 0 0 1-.402 1.355l-3.076 1.67-.239-.439a1.001 1.001 0 0 1 .402-1.356l3.076-1.67Zm5.272-2.863.24.439a1 1 0 0 1-.403 1.356l-3.076 1.67-.239-.44a1.001 1.001 0 0 1 .402-1.355l3.076-1.67ZM16.14 1.5l.239.439a1 1 0 0 1-.402 1.356L12.9 4.965l-.238-.439a1 1 0 0 1 .402-1.356L16.14 1.5Z",
  fill: "currentColor"
}));

export { minimalSeamsIcon as default };
//# sourceMappingURL=minimalSeamsIcon.js.map
